import { render, staticRenderFns } from "./demandConfirm_standard.vue?vue&type=template&id=6f05eaf2&scoped=true"
import script from "./demandConfirm_standard.vue?vue&type=script&lang=js"
export * from "./demandConfirm_standard.vue?vue&type=script&lang=js"
import style0 from "./demandConfirm_standard.vue?vue&type=style&index=0&id=6f05eaf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05eaf2",
  null
  
)

export default component.exports